module.exports = __webpack_public_path__ + "static/media/Grimace@3x.e0bc9afd.png";